module.exports = __webpack_public_path__ + "img/2023big12.10deee52.png";